<main class="container">
  <section class="col-8 mx-auto text-center">
    <header>
      <h1>Exercise Title</h1>
    </header>
    <div class="embed-responsive embed-responsive-16by9">
      <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/VB32073N4vY" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>
    <p class="my-5">Intro copy. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sit amet dignissim magna. Pellentesque porttitor placerat auctor. Nulla eu ultrices sapien. Nulla sollicitudin placerat viverra. Etiam sit amet dui lacinia, gravida neque eget, iaculis sapien. In viverra mauris non augue imperdiet bibendum. Vivamus dictum felis nisi, et consequat nisi sollicitudin eget.</p>
    <a class="btn btn-primary btn-lg">Get Started</a>
    <br><br>
    <a [routerLink]="['/ux/exercise/problem']">(Problem Exercise)</a>
    <a [routerLink]="['/ux/exercise/strategy']">(Strategy Exercise)</a>
  </section>
</main>
